import React from "react";
import moment from "moment";
import { Table } from "antd";
import { useIntl } from "react-intl";
import _ from "lodash";

const DailyPlan = (props) => {
  const { currentDate, print, activeRecord } = props;
  const intl = useIntl();

  let tableData = [];
  const numberOfDays = moment(currentDate).daysInMonth();
  var i;
  for (i = 0; i < numberOfDays; i++) {
    const currentDay = moment(currentDate).startOf("month").add(i, "days");

    const weekDay = currentDay.weekday();
    const isHoliday =
      activeRecord &&
      activeRecord.holidays &&
      activeRecord.holidays.filter(
        (item) => moment(item.date).date() === i + 1
      )[0];
    const allEvents = _.sortBy(
      [
        ...activeRecord.manual_events,
        ...activeRecord.scheduled_recurrent_events,
      ],
      [
        function (o) {
          return o.date;
        },
      ]
    );
    const dayEvents = allEvents.filter(
      (j) =>
        moment(j.date) >= currentDay.startOf("day") &&
        moment(j.date) <= currentDay.endOf("day")
    );

    const durationInMinutes = dayEvents.reduce((accumulator, object) => {
      return accumulator + object.duration_minutes;
    }, 0);
    const employeeType = activeRecord.employee.employee_type_id;

    const isHolocast = activeRecord?.order?.client?.category?.holocast_fund;
    const isForeignWorker =
      employeeType === 2 && !activeRecord.employee.tourist_with_license;
    const shouldRenderHours = isHolocast && isForeignWorker;

    const duration =
      durationInMinutes !== 0 && shouldRenderHours
        ? Math.round((durationInMinutes / 60) * 100) / 100
        : "";

    const entrance1 =
      dayEvents[0] && shouldRenderHours
        ? moment(dayEvents[0].date).format("HH:mm")
        : "";
    const entrance2 =
      dayEvents[1] && shouldRenderHours
        ? moment(dayEvents[1].date).format("HH:mm")
        : "";
    const exit1 =
      dayEvents[0] && shouldRenderHours
        ? moment(dayEvents[0].date)
            .add(dayEvents[0].duration_minutes, "minutes")
            .format("HH:mm")
        : "";
    const exit2 =
      dayEvents[1] && shouldRenderHours
        ? moment(dayEvents[1].date)
            .add(dayEvents[1].duration_minutes, "minutes")
            .format("HH:mm")
        : "";

    tableData.push({
      number: i + 1,
      day: moment.weekdays(weekDay),
      dayInWeek: weekDay,
      sum: duration,
      exit2: exit2,
      entrance2: entrance2,
      exit1: exit1,
      entrance1: entrance1,
      holiday:
        isHoliday !== undefined
          ? isHoliday.holiday_evening
            ? "ע.חג"
            : "חג"
          : "",
    });
  }
  const columns = [
    {
      dataIndex: "number",
      key: "description",
      width: "40px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.day",
      }),
      dataIndex: "day",
      key: "day",
      width: "80px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.holiday",
      }),
      dataIndex: "holiday",
      key: "holiday",
      width: "60px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.entrance",
      }),
      dataIndex: "entrance1",
      key: "entrance1",
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.exit",
      }),
      dataIndex: "exit1",
      key: "exit1",
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.entrance",
      }),
      dataIndex: "entrance2",
      key: "entrance2",
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.exit",
      }),
      dataIndex: "exit2",
      key: "exit2",
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.sum",
      }),
      dataIndex: "sum",
      key: "sum",
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.careGiverSignature",
      }),
      key: "careGiverSignature",
      width: "200px",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.weeklySignature",
      }),
      key: "weeklySignature",
      width: "200px",
      className: "signature",
      onCell: (_, index) => {
        return {
          colSpan: _.dayInWeek > 0 && _.number !== 1 ? 0 : 1,
          rowSpan: _.dayInWeek === 0 || _.number === 1 ? 7 - _.dayInWeek : 1,
        };
      },
    },
  ];

  return (
    <div>
      {print ? (
        <div className="vertical_spacer" />
      ) : (
        <div className="vertical_spacer high" />
      )}
      <Table
        bordered
        columns={columns}
        dataSource={tableData.map((i, index) => ({ ...i, key: index }))}
        rowKey={(record) => record.key}
        pagination={false}
        size="small"
        rowClassName={(record, index) => {
          return record.dayInWeek === activeRecord.rest_day || record.holiday
            ? "rest_day"
            : "";
        }}
      />
    </div>
  );
};

export default DailyPlan;
